import { getCurrentYear } from "shared/topchef.utils";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const lochallHelpUrl = String(t('externalUrls.lochall.help'));
  const lochallTermsUrl = String(t('externalUrls.lochall.terms'));
  const lochallCharterUrl = String(t('externalUrls.lochall.charter'));

  return (
    <footer id="footer" data-testid="footer" className="d-flex justify-content-between align-items-center py-3 px-5 border-top" style={{background: 'white', position: 'absolute', bottom: 0, right: 0, width: 'calc(100% - 250px)'}}>
      <span id="footer_credits">© {getCurrentYear()} LinkEvents</span>
      <div id="footer_links">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={lochallHelpUrl} target="_blank" rel="noreferrer" className="me-3 text-decoration-none">{t('footer.help')}</a>
        <a href={lochallTermsUrl} target="_blank" rel="noreferrer" className="me-3 text-decoration-none">{t('footer.generalConditions')}</a>
        <a href={lochallCharterUrl} target="_blank" rel="noreferrer" className="me-3 text-decoration-none">{t('footer.charter')}</a>
        <a href="mailto:linkevents@lochall.com" className="text-decoration-none">{t('footer.contactSupport')}</a>
      </div>
    </footer>
  );

}

export default Footer;
